<template>
  <div class="honor-container">
    <div class="honor-head">
        <p>{{title}}</p>
    </div>
    <div class="honor-content">
        <img :src="bgimg2" alt="">
    </div>
  </div>
</template>

<script>
// import bgimg from "@/assets1/关于我们_slices/背景.png"
// import bgimg2 from "@/assets1/关于我们_slices/证书 (1).png"
export default {
props:{
    title:{
        type:String,
        required:true
    },
    imglist:{
        type:Array,
          required:true
    }
}
,data(){
    return{
     bgimg2:'https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC/%E8%AF%81%E4%B9%A6%20%281%29.png'
    }
}
}
</script>

<style scoped>
.honor-content{
  
        width: 1200px;
        height: 1227px;

}
.honor-content img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.imgBox{
    padding: 5px;
    background-color: #fff;
    border-radius: 10px;
    margin-right: 24px;
}
.imgBox:last-child{
     margin-right: 0;
}
.imgBox img{
    width: 200px;
    height: 149px;
    object-fit: cover;
}
.honor-container{
    padding-top: 100px;
    width: 1920px;
   height: 1541px;
    background-image:url('https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC/%E8%83%8C%E6%99%AF.png');
    display:flex;
    flex-direction: column;
    align-items: center;
}
.honor-head{
    font-family: Medium;
    font-size: 35px;
    font-weight: 500;
    color: white;
    margin-bottom: 70px;
}
</style>